(() => {
  if (window.cartCompatibilityDismissalsInitialized) return;
  window.cartCompatibilityDismissalsInitialized = true;

  const storageKey = 'cart-compatibility-dismissed-rules';
  const alertSelector = '.cart-compatibility__alert[data-compatibility-rule]';
  const dismissSelector = '[data-compatibility-dismiss]';

  const getDismissedRules = () => {
    try {
      const storedRules = JSON.parse(sessionStorage.getItem(storageKey));
      return new Set(Array.isArray(storedRules) ? storedRules : []);
    } catch (error) {
      return new Set();
    }
  };

  const dismissedRules = getDismissedRules();

  const storeDismissedRules = () => {
    try {
      sessionStorage.setItem(storageKey, JSON.stringify([...dismissedRules]));
    } catch (error) {
      // The alert still closes when sessionStorage is unavailable.
    }
  };

  const initializeAlerts = (root = document) => {
    const alerts = [];

    if (root.nodeType === Node.ELEMENT_NODE && root.matches(alertSelector)) {
      alerts.push(root);
    }

    if (root.querySelectorAll) {
      alerts.push(...root.querySelectorAll(alertSelector));
    }

    alerts.forEach((alert) => {
      alert.hidden = dismissedRules.has(alert.dataset.compatibilityRule);
      alert.setAttribute('data-compatibility-ready', '');
    });
  };

  const resetResolvedDismissals = () => {
    if (!document.querySelector('.cart-compatibility')) return;

    const activeRules = new Set(
      [...document.querySelectorAll(alertSelector)].map((alert) => alert.dataset.compatibilityRule)
    );
    let dismissalsChanged = false;

    dismissedRules.forEach((rule) => {
      if (!activeRules.has(rule)) {
        dismissedRules.delete(rule);
        dismissalsChanged = true;
      }
    });

    if (dismissalsChanged) storeDismissedRules();
  };

  document.addEventListener('click', (event) => {
    const dismissButton = event.target.closest(dismissSelector);
    if (!dismissButton) return;

    const alert = dismissButton.closest(alertSelector);
    if (!alert) return;

    dismissedRules.add(alert.dataset.compatibilityRule);
    storeDismissedRules();

    document.querySelectorAll(alertSelector).forEach((matchingAlert) => {
      if (matchingAlert.dataset.compatibilityRule === alert.dataset.compatibilityRule) {
        matchingAlert.hidden = true;
      }
    });
  });

  initializeAlerts();
  resetResolvedDismissals();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach(initializeAlerts);
    });
    resetResolvedDismissals();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
